import React from 'react'
import Layout from '../../components/Layout'
import constants from '../../config/constants'
import { connect } from 'react-redux'
import actions from '../../redux/actions'
import { Form, Input, Icon, Row, Col, Checkbox, Radio } from 'antd';
import styled from 'styled-components'
import Divider from '../../components/Divider';
import ProgressBar from '../../components/ProgressBar';
import ButtonComponent from '../../components/Button';
import IMask from 'imask';

const Personalnformation = styled.div`
  margin-top: 2rem !important;

  input {
    height: 45px !important;
    font-size: 16px !important;
    border: 1px solid ${constants.color.lightDark} !important;
    width: 100%;
    padding: 4px 11px;
    border-radius: 8px;
    caret-color: ${constants.color.blue} !important;
    line-height: 24.3px !important;
    box-shadow: none !important;

    &:focus {
      border: 1px solid ${constants.color.blue} !important;
      box-shadow: none !important;
    }
  }

  input[type="date"]::before {
    color:${constants.color.lightDark};
    content: attr(placeholder);
  }

  input[type="date"] {
    color: ${constants.color.white};
  }

  input[type="date"]:focus,
  input[type="date"]:valid {
    color:${constants.color.white} !important;
    content: attr(placeholder);
  }

  input[type="date"]:focus::before,
  input[type="date"]:valid::before {
    content: attr(placeholder);
    color:${constants.color.dark};
  }

  .ant-input {
    color: ${constants.color.dark} !important;
    border: 1px solid ${constants.color.lightDark} !important;
    line-height: 24.3px !important;
    caret-color: ${constants.color.blue} !important;

    &:focus {
      border: 1px solid ${constants.color.blue} !important;
      box-shadow: none !important;
    }

    &::placeholder {
      color: ${constants.color.lightDark} !important;
    }
  }

  .ant-form-item-required::before {
    content: '' !important;
    margin-right: 0 !important;
  }

  .ant-form-item-label > label {
    font-family: 'Thonburi';
    color: ${constants.color.mediumDark} !important;
  }

  .ant-form-item-control {

    .ant-form-extra {
      font-size: 12px !important;
      color: ${constants.color.mediumDark} !important;
    }
  }

  .has-error .ant-form-explain, .has-error .ant-form-split {
    color: ${constants.color.red} !important;
  }
`

const Title = styled(Col)`
  color: ${constants.color.mediumDark};
`

const Description = styled(Col)`
  color: ${constants.color.dark};
  text-align: end !important;
`

const CheckboxRow = styled(Row)`
  margin-left: .3rem;

  .ant-col {
    margin-top: .3rem;
  }

  .ant-checkbox + span {
    padding-left: 15px !important;
  }

  .ant-checkbox-wrapper {
    color: ${constants.color.dark} !important;


    .ant-checkbox-inner {
      width: 24px !important;
      height: 24px !important;
      border-radius: 4px;
    }

    .ant-checkbox-checked::after {
      border: none !important;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${constants.color.darkBlue};
      border: none !important;

      &::after {
        border: 1.5px solid ${constants.color.white} !important;
        top: 55% !important;
        left: 30% !important;
        width: 5px !important;
        border-top: 0 !important;
        border-left: 0 !important;
        height: 10px !important;
        transform: rotate(45deg) scale(1.5) translate(-50%, -50%) !important;


    &:hover, :focus {
      .ant-checkbox-inner {
        border-color: ${constants.color.lightGrey1} !important;
      }
    }
  }


  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${constants.color.darkBlue} !important;
    border: none !important;
  }
`

const CheckboxSingle = styled(Checkbox)`
  margin-left: .3rem;
  margin-bottom: 1rem;

  .ant-checkbox-inner {
    width: 24px !important;
    height: 24px !important;
    border-radius: 4px;
  }

  .ant-checkbox-checked::after {
    border: none !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${constants.color.darkBlue};
    border: none !important;

    &::after {
      border: 1.5px solid ${constants.color.white} !important;
      top: 55% !important;
      left: 30% !important;
      width: 5px !important;
      border-top: 0 !important;
      border-left: 0 !important;
      height: 10px !important;
      transform: rotate(45deg) scale(1.5) translate(-50%, -50%) !important;
    }

    &:hover, :focus {
      .ant-checkbox-inner {
        border-color: ${constants.color.lightGrey1} !important;
      }
    }
  }

  .ant-checkbox + span {
    padding-left: 15px !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${constants.color.darkBlue} !important;
    border: none !important;
  }
`

const StyledRow = styled(Row)`
  margin-bottom: 1em;
`

const RadioButton = styled(Radio.Group)`
  display: table !important;
  text-align: center !important;
  color: ${constants.color.dark} !important;
  width: 100% !important;
  margin: 0 auto !important;

  .ant-radio-button-wrapper-checked {

    color: ${constants.color.white} !important;
    border-color: ${constants.color.lightOrange} !important;
    background:${constants.color.lightOrange} !important;
  }

  .ant-radio-button-wrapper {
    z-index: 0 !important;
    border-radius: 25px !important;
    width: 48% !important;
    margin: .5rem 0 !important;
    border: 1px solid ${constants.color.lightDark};
    color: ${constants.color.dark};
    box-shadow: -1px 0 0 0 ${constants.color.white} !important;
    font-size: 16px !important;
    height: 40px !important;
    line-height: 35px !important;

    &:nth-child(odd) {
      float: left;
    }

    &:nth-child(even) {
      float: right;
    }
  }

  .ant-radio-button-wrapper:not(:first-child)::before {
    height: 0;
  }
`

const FormItemRadio = styled(Form.Item)`
  margin-bottom: 10px !important;
`

const RadioVertical = styled(Radio.Group)`
  display: block !important;

  .ant-form-item-label {
    color: ${constants.color.mediumDark} !important;
  }

  .ant-radio-wrapper {
    min-height: 35px !important;
    width: 100%;
    padding-left: 5px;
    display: flex;

    span.ant-radio + * {
      font-size: 14px !important;
      padding-right: 8px;
      padding-left: 15px;
      color: ${constants.color.dark} !important;
    }

    input[type='radio'] {
      width: 24px !important;
      height: 24px !important;
    }

    .ant-radio-checked::after {
      display: none !important;
    }

    .ant-radio-inner {
      width: 24px !important;
      height: 24px !important;
      border-color: ${constants.color.lightGrey1};

      &::after {
        width: 14px !important;
        height: 14px !important;
        top: 4px !important;
        left: 4px !important;
        transition: none !important;
        background-color: ${constants.color.darkBlue} !important;
      }
    }

    .ant-radio-checked .ant-radio-inner,
    .ant-radio-wrapper:hover,
    .ant-radio-checked::after {
      border-color: ${constants.color.darkBlue} !important;
    }
  }
`

const AdressDescription = styled.p`
  color: ${constants.color.dark};
`

const  AdressForm =  styled(Form.Item)`
  .ant-form-item-children {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: #000000a6;
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    -webkit-font-feature-settings: 'tnum';
    font-feature-settings: 'tnum', "tnum";
    position: relative;
    display: inline-block;
    width: 100%;
    text-align: start;
  }

  textarea.ant-input {
    padding-right: 30px;
    resize: none;
    font-size: 16px !important;
    height: 50px;
    border-radius: 8px;
    line-height: 21.6px !important;
    margin-bottom: -.5em;

    &::placeholder {
      color: ${constants.color.lightDark} !important;
      padding-top: 0.6rem;
    }

  }

  .ant-input-suffix {
    right: 12px;
    position: absolute;
    top: 50%;
    z-index: 2;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    color: #000000a6;
    line-height: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
`

class PersonalInformationForm extends React.Component {
    state = {
      confirmDirty: false
    };

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err) => {
          if (!err) {
            console.log(this.props.userInfomations)
            this.props.history.push('/confirm-email');
          }
        });
    };

    handleCompanyNameChange = (e) => {
      this.props.setCompanyName( e.target.value);
    };

    handleIncomeChange(checkedValues) {
      this.props.setIncome(checkedValues);
    }

    handleObjectiveChange(checkedValues) {
      this.props.setObjective(checkedValues);
    }

    handleCurrentAddressChange = (event) => {
      this.props.setCurrentAddress(event.target.checked);
    }

    handleCurrentNumberChange = (e) => {
      this.props.setCurrentNumber( e.target.value);
    };

    handleCurrentVillageNameChange = (e) => {
      this.props.setCurrentVillageName( e.target.value);
    };

    handleCurrentVillageChange = (e) => {
      this.props.setCurrentVillage( e.target.value);
    };

    handleCurrentFloorChange = (e) => {
      this.props.setCurrentFloor( e.target.value);
    };

    handleCurrentRoadChange = (e) => {
      this.props.setCurrentRoad( e.target.value);
    };

    handleWorkAddressChange = (event) => {
      this.props.setWorkAddress(event.target.value);
    }

    handleWorkNumberChange = (e) => {
      this.props.setWorkNumber( e.target.value);
    };

    handleWorkVillageNameChange = (e) => {
      this.props.setWorkVillageName( e.target.value);
    };

    handleWorkVillageChange = (e) => {
      this.props.setWorkVillage( e.target.value);
    };

    handleWorkFloorChange = (e) => {
      this.props.setWorkFloor( e.target.value);
    };

    handleWorkRoadChange = (e) => {
      this.props.setWorkRoad( e.target.value);
    };

    handleDocumentAddressChange = (event) => {
      this.props.setDocumentAddress(event.target.value);
    }

    handleDocumentNumberChange = (e) => {
      this.props.setDocumentNumber( e.target.value);
    };

    handleDocumentVillageNameChange = (e) => {
      this.props.setDocumentVillageName( e.target.value);
    };

    handleDocumentVillageChange = (e) => {
      this.props.setDocumentVillage( e.target.value);
    };

    handleDocumentFloorChange = (e) => {
      this.props.setDocumentFloor( e.target.value);
    };

    handleDocumentRoadChange = (e) => {
      this.props.setDocumentRoad( e.target.value);
    };

    handleMaritalStatusChange = (event) => {
      this.props.setMaritalStatus(event.target.value);
    }

    handleSpouseNationalityChange = (event) => {
      this.props.setSpouseNationality(event.target.value);
    }

    handleFristChildrenNationalityChange = (event) => {
      this.props.setFristChildrenNationality(event.target.value)
    }

    handleSecondChildrenNationalityChange = (event) => {
      this.props.setSecondChildrenNationality(event.target.value)
    }

    handleSpouseCitizenIdChange= (event) => {
      const maskOptions = {
        mask : "0-0000-00000-00-0"
      };
      const mask = IMask(event.target, maskOptions);
      if(event.target.validity.valid){
        this.props.setSpouseCitizenId(mask.value);
        return mask.value
      } else {
        return this.props.userInfomations.spouseCitizenId
      }
    }

    handleFristChildrenCitizenIdChange= (event) => {
      const maskOptions = {
        mask : "0-0000-00000-00-0"
      };
      const mask = IMask(event.target, maskOptions);
      if(event.target.validity.valid){
        this.props.setFristChildrenCitizenId(mask.value);
        return mask.value
      } else {
        return this.props.userInfomations.fristChildrenCitizenId
      }
    }

    handleSecondChildrenCitizenIdChange= (event) => {
      const maskOptions = {
        mask : "0-0000-00000-00-0"
      };
      const mask = IMask(event.target, maskOptions);
      if(event.target.validity.valid){
        this.props.setSecondChildrenCitizenId(mask.value);
        return mask.value
      } else {
        return this.props.userInfomations.secondChildrenCitizenId
      }
    }

    handleSpouseCitizenIdExpireDateChange = (event) => {
      const spouseCitizenIdExpireDate = this.covertDate(event.target.value);
      this.props.setSpouseCitizenIdExpireDate(event.target.value, spouseCitizenIdExpireDate);
      return event.target.value
    }

    handleFristChildrenCitizenIdExpireDateChange = (event) => {
      const fristChildrenCitizenIdExpireDate = this.covertDate(event.target.value);
      this.props.setFristChildrenCitizenIdExpireDate(event.target.value, fristChildrenCitizenIdExpireDate);
      return event.target.value
    }

    handleSecondChildrenCitizenIdExpireDateChange = (event) => {
      const secondChildrenCitizenIdExpireDate = this.covertDate(event.target.value);
      this.props.setSecondChildrenCitizenIdExpireDate(event.target.value, secondChildrenCitizenIdExpireDate);
      return event.target.value
    }

    handleSpouseLifeLongCitizenIdChange = (event) => {
      this.props.setSpouseLifeLongCitizenId(event.target.checked);
    }

    handleSpousePassportNoChange = (event) => {
      const passportNo = event.target.value;
      this.props.setSpousePassportNo(passportNo.toUpperCase());
      return passportNo.toUpperCase();
    }

    handleFristChildrenPassportNoChange = (event) => {
      const passportNo = event.target.value;
      this.props.setFristChildrenPassportNo(passportNo.toUpperCase());
      return passportNo.toUpperCase();
    }

    handleSecondChildrenPassportNoChange = (event) => {
      const passportNo = event.target.value;
      this.props.setSecondChildrenPassportNo(passportNo.toUpperCase());
      return passportNo.toUpperCase();
    }

    handleSpousePassportNoExpireDateChange = (event) => {
      const spousePassportNoExpireDate = this.covertDate(event.target.value);
      this.props.setSpousePassportNoExpireDate(event.target.value, spousePassportNoExpireDate);
      return event.target.value
    }

    handleFristChildrenPassportNoExpireDateChange = (event) => {
      const fristChildrenPassportNoExpireDate = this.covertDate(event.target.value);
      this.props.setFristChildrenPassportNoExpireDate(event.target.value, fristChildrenPassportNoExpireDate);
      return event.target.value
    }

    handleSecondChildrenPassportNoExpireDateChange = (event) => {
      const secondChildrenPassportNoExpireDate = this.covertDate(event.target.value);
      this.props.setSecondChildrenPassportNoExpireDate(event.target.value, secondChildrenPassportNoExpireDate);
      return event.target.value
    }

    handleSpouseNameChange = (event) => {
      this.props.setSpouseName(event.target.value);
    }

    handleFristChildrenNameChange = (event) => {
      this.props.setFristChildrenName(event.target.value);
    }

    handleSecondChildrenNameChange = (event) => {
      this.props.setSecondChildrenName(event.target.value);
    }

    covertDate = (date) => {
      const monthData = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
    ];
      const splitDate = (date).split('-');
      const day = splitDate[2];
      const month = splitDate[1];
      const year = Number(splitDate[0]) + 543;
      return day + ' ' + monthData[Number(month) - 1] + ' ' + year;
    }

    componentDidMount = () => {
      console.log(this.props.userInfomations);
      if(this.props.userInfomations.occupationId === 170) {
        this.props.form.setFieldsValue({
          'occupation': this.props.userInfomations.otherOccupation,
        });
      } else {
        this.props.form.setFieldsValue({
          'occupation': this.props.userInfomations.occupation,
        });
      }

      if(this.props.userInfomations.businessTypeId === 180) {
        this.props.form.setFieldsValue({
          'businessType': this.props.userInfomations.otherBusinessType
        });
      } else {
        this.props.form.setFieldsValue({
          'businessType': this.props.userInfomations.businessType,
        });
      }

      if(this.props.userInfomations.spouseTitleId === 'OTHER') {
        this.props.form.setFieldsValue({
          'spouseTitle': this.props.userInfomations.otherTitle
        });
      } else {
        this.props.form.setFieldsValue({
          'spouseTitle': this.props.userInfomations.spouseTitle
        });
      }

      let address = null;
      if(this.props.userInfomations.province && this.props.userInfomations.district
      && this.props.userInfomations.subDistrict && this.props.userInfomations.zipcode) {
        if(this.props.userInfomations.provinceId === '1') {
          address = `${this.props.userInfomations.province} , เขต${this.props.userInfomations.district},\n`+
          `แขวง${this.props.userInfomations.subDistrict} ${this.props.userInfomations.zipcode}`
        } else {
          address = `${this.props.userInfomations.province} , อำเภอ${this.props.userInfomations.district},\n`+
          `ตำบล${this.props.userInfomations.subDistrict} ${this.props.userInfomations.zipcode}`
        }
      }

      let currentAddress = null;
      if(this.props.userInfomations.currentProvince && this.props.userInfomations.currentDistrict
      && this.props.userInfomations.currentSubDistrict && this.props.userInfomations.currentZipcode) {
        if(this.props.userInfomations.currentProvince === '1') {
          currentAddress = `${this.props.userInfomations.currentProvince} , เขต${this.props.userInfomations.currentDistrict},\n`+
          `แขวง${this.props.userInfomations.currentSubDistrict} ${this.props.userInfomations.currentZipcode}`
        } else {
          currentAddress = `${this.props.userInfomations.currentProvince} , อำเภอ${this.props.userInfomations.currentDistrict},\n`+
          `ตำบล${this.props.userInfomations.currentSubDistrict} ${this.props.userInfomations.currentZipcode}`
        }
      }

      let workAddress = null;
      if(this.props.userInfomations.workProvince && this.props.userInfomations.workDistrict
      && this.props.userInfomations.workSubDistrict && this.props.userInfomations.workZipcode) {
        if(this.props.userInfomations.workProvince === '1') {
          workAddress = `${this.props.userInfomations.workProvince} , เขต${this.props.userInfomations.workDistrict},\n`+
          `แขวง${this.props.userInfomations.workSubDistrict} ${this.props.userInfomations.workZipcode}`
        } else {
          workAddress = `${this.props.userInfomations.workProvince} , อำเภอ${this.props.userInfomations.workDistrict},\n`+
          `ตำบล${this.props.userInfomations.workSubDistrict} ${this.props.userInfomations.workZipcode}`
        }
      }

      let documentAddress = null;
      if(this.props.userInfomations.documentProvince && this.props.userInfomations.documentDistrict
      && this.props.userInfomations.documentSubDistrict && this.props.userInfomations.documentZipcode) {
        if(this.props.userInfomations.documentProvince === '1') {
          documentAddress = `${this.props.userInfomations.documentProvince} , เขต${this.props.userInfomations.documentDistrict},\n`+
          `แขวง${this.props.userInfomations.documentSubDistrict} ${this.props.userInfomations.documentZipcode}`
        } else {
          documentAddress = `${this.props.userInfomations.documentProvince} , อำเภอ${this.props.userInfomations.documentDistrict},\n`+
          `ตำบล${this.props.userInfomations.documentSubDistrict} ${this.props.userInfomations.documentZipcode}`
        }
      }

      this.props.form.setFieldsValue({
        'salary': this.props.userInfomations.salary,
        'country': this.props.userInfomations.country,
        'companyName': this.props.userInfomations.companyName,
        'income': this.props.userInfomations.income,
        'objective': this.props.userInfomations.objective,
        'address': address,
        'currentNumber': this.props.userInfomations.currentNumber,
        'currentVillageName': this.props.userInfomations.currentVillageName,
        'currentVillage': this.props.userInfomations.currentVillage,
        'currentFloor': this.props.userInfomations.currentFloor,
        'currentRoad': this.props.userInfomations.currentRoad,
        'currentAddress': currentAddress,
        'radioWorkAddress' : this.props.userInfomations.workAddress,
        'workNumber': this.props.userInfomations.workNumber,
        'workVillageName': this.props.userInfomations.workVillageName,
        'workVillage': this.props.userInfomations.workVillage,
        'workFloor': this.props.userInfomations.workFloor,
        'workRoad': this.props.userInfomations.workRoad,
        'workAddress': workAddress,
        'radioDocumentAddress' : this.props.userInfomations.documentAddress,
        'documentNumber': this.props.userInfomations.documentNumber,
        'documentVillageName': this.props.userInfomations.documentVillageName,
        'documentVillage': this.props.userInfomations.documentVillage,
        'documentFloor': this.props.userInfomations.documentFloor,
        'documentRoad': this.props.userInfomations.documentRoad,
        'documentAddress': documentAddress,
        'children': this.props.userInfomations.children,
        'maritalStatus': this.props.userInfomations.maritalStatus || 'Single',
        'spouseNationality': this.props.userInfomations.spouseNationalityId || 'Thai',
        'spouseCitizenId': this.props.userInfomations.spouseCitizenId,
        'spouseCitizenIdExpireDate': this.props.userInfomations.spouseCitizenIdExpireDate,
        'spousePassportNo': this.props.userInfomations.spousePassportNo,
        'spousePassportNoExpireDate': this.props.userInfomations.spousePassportNoExpireDate,
        'spouseCountry': this.props.userInfomations.spouseCountry,
        'spouseName': this.props.userInfomations.spouseName,
        'fristChildrenNationality': this.props.userInfomations.fristChildrenNationalityId || 'Thai',
        'fristChildrenCitizenId': this.props.userInfomations.fristChildrenCitizenId,
        'fristChildrenCitizenIdExpireDate': this.props.userInfomations.fristChildrenCitizenIdExpireDate,
        'fristChildrenPassportNo': this.props.userInfomations.fristChildrenPassportNo,
        'fristChildrenPassportNoExpireDate': this.props.userInfomations.fristChildrenPassportNoExpireDate,
        'fristChildrenCountry': this.props.userInfomations.fristChildrenCountry,
        'fristChildrenName': this.props.userInfomations.fristChildrenName,
        'fristChildrenTitle': this.props.userInfomations.fristChildrenTitle,
        'secondChildrenNationality': this.props.userInfomations.secondChildrenNationalityId || 'Thai',
        'secondChildrenCitizenId': this.props.userInfomations.secondChildrenCitizenId,
        'secondChildrenCitizenIdExpireDate': this.props.userInfomations.secondChildrenCitizenIdExpireDate,
        'secondChildrenPassportNo': this.props.userInfomations.secondChildrenPassportNo,
        'secondChildrenPassportNoExpireDate': this.props.userInfomations.secondChildrenPassportNoExpireDate,
        'secondChildrenCountry': this.props.userInfomations.secondChildrenCountry,
        'secondChildrenName': this.props.userInfomations.secondChildrenName,
        'secondChildrenTitle': this.props.userInfomations.secondChildrenTitle
      });
    }

    render() {
      const { getFieldDecorator } = this.props.form;

      const formItemLayout = {
        labelCol: { span: 24 },
        wrapperCol: {span: 24 },
      };

      const otherDocumentAddress = [25,70,140,150,160,170];

      return (
        <Layout
          title={'ข้อมูลส่วนตัว'}
          backIcon={true}
          onClick={() => this.props.history.push('/on-boarding-stage')}
          >
          <ProgressBar percent={25}/>
          <Personalnformation>
            <h5 style={{marginBottom: '1rem'}}>ข้อมูลส่วนตัว</h5>
            <StyledRow>
              <Title span={12}>เลขที่ประจำตัวบัตรประชาชน</Title>
              <Description span={12}>1-234-56789-12-3</Description>
            </StyledRow>
            <StyledRow>
              <Title span={12}>วันบัตรหมดอายุ</Title>
              <Description span={12}>11 พ.ย. 2563</Description>
            </StyledRow>
            <StyledRow>
              <Title span={12}>คำนำหน้า</Title>
              <Description span={12}>นาง</Description>
            </StyledRow>
            <StyledRow>
              <Title span={12}>ชื่อ - นามสกุล</Title>
              <Description span={12}>ปราถนา สิงหาคม</Description>
            </StyledRow>
            <StyledRow>
              <Title span={12}>Title</Title>
              <Description span={12}>Miss</Description>
            </StyledRow>
            <StyledRow>
              <Title span={12}>First name - Last name</Title>
              <Description span={12}>Pratthana Saingam</Description>
            </StyledRow>
            <StyledRow>
              <Title span={12}>วัน/เดือน/ปีเกิด</Title>
              <Description span={12}>1 ส.ค. 2532</Description>
            </StyledRow>
            <StyledRow>
              <Title span={12}>สัญชาติ</Title>
              <Description span={12}>ไทย</Description>
            </StyledRow>
            <Divider floatRight={true} floatLeft={true} height={5}/>
            <Form {...formItemLayout} onSubmit={this.handleSubmit}>
              <h5 style={{margin: '1rem 0'}}>ข้อมูลสถานที่ทำงาน</h5>
              <Form.Item label="อาชีพ">
                {getFieldDecorator('occupation', {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณาเลือกอาชีพ',
                    }
                  ],
                  })(<Input
                    placeholder="เลือกอาชีพ"
                    suffix={<Icon type="right"/>}
                    onClick={() => this.props.history.push('/select-occ')}
                  />)}
              </Form.Item>
              <Form.Item label="ประเภทธุรกิจ">
                {getFieldDecorator('businessType', {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณาเลือกประเภท',
                    }
                  ],
                  })(<Input
                    placeholder="เลือกประเภท"
                    suffix={<Icon type="right"/>}
                    onClick={() => this.props.history.push('/select-business-type')}
                  />)}
              </Form.Item>
              <Form.Item label={'ชื่อบริษัท หรือชื่อกิจการ'}>
                {getFieldDecorator('companyName', {
                    rules: [{ required: true,  min: 2, message: 'กรุณากรอกชื่อที่ทำงาน', whitespace: true }],
                })(<Input placeholder='กรอกชื่อที่ทำงาน' onChange={this.handleCompanyNameChange} />)}
              </Form.Item>
              <Form.Item label="รายได้ต่อเดือน (บาท)">
                {getFieldDecorator('salary', {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณาเลือกรายได้ต่อเดือน',
                    }
                  ],
                  })(<Input
                    placeholder="เลือกรายได้ต่อเดือน"
                    suffix={<Icon type="right"/>}
                    onClick={() => this.props.history.push('/select-salary')}
                  />)}
              </Form.Item>
              <Form.Item label="ประเทศแหล่งที่มาของรายได้">
                {getFieldDecorator('country', {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณาเลือกประเทศแหล่งที่มาของรายได้',
                    }
                  ],
                  })(<Input
                    placeholder="เลือกประเทศแหล่งที่มาของรายได้"
                    suffix={<Icon type="right"/>}
                    onClick={() => this.props.history.push('/select-country')}
                  />)}
              </Form.Item>
              <Form.Item label="แหล่งที่มาของรายได้ (เลือกได้มากกว่า 1 ข้อ)">
                {getFieldDecorator('income', {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณาเลือก',
                    }
                  ],
                  })(
                    <Checkbox.Group style={{ width: '100%' }} onChange={this.handleIncomeChange.bind(this)}>
                      <CheckboxRow>
                        <Col span={24}>
                          <Checkbox value="1">เงินเดือน</Checkbox>
                        </Col>
                        <Col span={24}>
                          <Checkbox value="2">เงินออม</Checkbox>
                        </Col>
                        <Col span={24}>
                          <Checkbox value="3">เงินเกษียณ</Checkbox>
                        </Col>
                        <Col span={24}>
                          <Checkbox value="4">มรดก</Checkbox>
                        </Col>
                        <Col span={24}>
                          <Checkbox value="5">การลงทุน</Checkbox>
                        </Col>
                        <Col span={24}>
                          <Checkbox value="6">ประกอบธุรกิจ</Checkbox>
                        </Col>
                        <Col span={24}>
                          <Checkbox value="7">อื่นๆ</Checkbox>
                        </Col>
                      </CheckboxRow>
                    </Checkbox.Group>
                  )}
              </Form.Item>
              <Form.Item label="วัตถุประสงค์การลงทุน (เลือกได้มากกว่า 1 ข้อ)">
                {getFieldDecorator('objective', {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณาเลือก',
                    }
                  ],
                  })(
                    <Checkbox.Group style={{ width: '100%' }} onChange={this.handleObjectiveChange.bind(this)}>
                      <CheckboxRow>
                        <Col span={24}>
                          <Checkbox value="1">เพื่อการลงทุนระยะสั้น</Checkbox>
                        </Col>
                        <Col span={24}>
                          <Checkbox value="2">เพื่อการลงทุนระยะยาว</Checkbox>
                        </Col>
                        <Col span={24}>
                          <Checkbox value="3">เพื่อการเกษียณ</Checkbox>
                        </Col>
                        <Col span={24}>
                          <Checkbox value="4">เพื่อเก็บออม</Checkbox>
                        </Col>
                        <Col span={24}>
                          <Checkbox value="5">เพื่อสิทธิประโยชน์ทางภาษี</Checkbox>
                        </Col>
                        <Col span={24}>
                          <Checkbox value="6">อื่นๆ</Checkbox>
                        </Col>
                      </CheckboxRow>
                    </Checkbox.Group>
                  )}
              </Form.Item>
              <Divider floatRight={true} floatLeft={true} height={5}/>
              <h5 style={{margin: '1rem 0'}}>ข้อมูลที่อยู่ตามทะเบียนบ้าน</h5>
              <AdressDescription>224/88 AIA Building 18 fl. เกษรนวมินทร์</AdressDescription>
              <AdressForm label="จังหวัด, อำเภอ, ตำบล">
                {getFieldDecorator('address', {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณาเลือกข้อมูล'
                    }
                  ],
                  })(
                    <Input.TextArea
                      placeholder="เลือกข้อมูล"
                      onClick={() => this.props.history.push('/select-province')}
                    />)}
                  <span className="ant-input-suffix">
                    <Icon type="right"/>
                  </span>
              </AdressForm>
              <h5 style={{margin: '1rem 0'}}>ข้อมูลที่อยู่ปัจจุบัน</h5>
              <CheckboxSingle
                onChange={this.handleCurrentAddressChange.bind(this)}
                checked={this.props.userInfomations.currentAddress}>ข้อมูลเดียวกับที่อยู่ตามทะเบียนบ้าน
              </CheckboxSingle>

              {!this.props.userInfomations.currentAddress &&
              <>
                <Form.Item label={'เลขที่'}>
                  {getFieldDecorator('currentNumber', {
                      rules: [{ required: true,  min: 1, message: 'กรุณากรอกเลขที่', whitespace: true }],
                  })(<Input placeholder='กรอกเลขที่' onChange={this.handleCurrentNumberChange} />)}
                </Form.Item>
                <Form.Item label={'ชื่ออาคาร หรือหมู่บ้าน'}>
                  {getFieldDecorator('currentVillageName')(
                    <Input placeholder='กรอกชื่ออาคาร (ถ้ามี)' onChange={this.handleCurrentVillageNameChange} />
                  )}
                </Form.Item>
                <Form.Item label={'หมู่'}>
                  {getFieldDecorator('currentVillage')(
                    <Input placeholder='กรอกหมู่ (ถ้ามี)' onChange={this.handleCurrentVillageChange} />
                  )}
                </Form.Item>
                <Form.Item label={'ชั้น'}>
                  {getFieldDecorator('currentFloor')(
                    <Input placeholder='กรอกชั้น (ถ้ามี)' onChange={this.handleCurrentFloorChange} />
                  )}
                </Form.Item>
                <Form.Item label={'ถนน'}>
                  {getFieldDecorator('currentRoad')(
                    <Input placeholder='กรอกชื่อถนน' onChange={this.handleCurrentRoadChange} />
                  )}
                </Form.Item>
                <AdressForm label="จังหวัด, อำเภอ, ตำบล">
                  {getFieldDecorator('currentAddress', {
                    rules: [
                      {
                        required: true,
                        message: 'กรุณาเลือกข้อมูล'
                      }
                    ],
                    })(
                      <Input.TextArea
                        placeholder="เลือกข้อมูล"
                        onClick={() => this.props.history.push('/select-current-province')}
                      />)}
                    <span className="ant-input-suffix">
                      <Icon type="right"/>
                    </span>
                </AdressForm>
              </>
              }

              <h5 style={{marginBottom: '1rem'}}>ข้อมูลสถานที่ทำงาน</h5>
              <FormItemRadio>
                {getFieldDecorator('radioWorkAddress', {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณาเลือก'
                    }
                  ],
                  })(
                  <RadioVertical onChange={this.handleWorkAddressChange}>
                    <Radio value={'current'}>ใช้ตามที่อยู่ทะเบียนบ้าน</Radio>
                    {
                      !this.props.userInfomations.currentAddress && <Radio value={'houseRegister'}>ใช้ตามที่อยู่ปัจจุบัน</Radio>
                    }
                    <Radio value={'other'}>ใช้ที่อยู่อื่น</Radio>
                  </RadioVertical>,
                )}
              </FormItemRadio>

              {this.props.userInfomations.workAddress === 'other' &&
              <>
                <Form.Item label={'เลขที่'}>
                  {getFieldDecorator('workNumber', {
                      rules: [{ required: true,  min: 1, message: 'กรุณากรอกเลขที่', whitespace: true }],
                  })(<Input placeholder='กรอกเลขที่' onChange={this.handleWorkNumberChange} />)}
                </Form.Item>
                <Form.Item label={'ชื่ออาคาร หรือหมู่บ้าน'}>
                  {getFieldDecorator('workVillageName')(
                    <Input placeholder='กรอกชื่ออาคาร (ถ้ามี)' onChange={this.handleWorkVillageNameChange} />
                  )}
                </Form.Item>
                <Form.Item label={'หมู่'}>
                  {getFieldDecorator('workVillage')(
                    <Input placeholder='กรอกหมู่ (ถ้ามี)' onChange={this.handleWorkVillageChange} />
                  )}
                </Form.Item>
                <Form.Item label={'ชั้น'}>
                  {getFieldDecorator('workFloor')(
                    <Input placeholder='กรอกชั้น (ถ้ามี)' onChange={this.handleWorkFloorChange} />
                  )}
                </Form.Item>
                <Form.Item label={'ถนน'}>
                  {getFieldDecorator('workRoad')(
                    <Input placeholder='กรอกชื่อถนน' onChange={this.handleWorkRoadChange} />
                  )}
                </Form.Item>
                <AdressForm label="จังหวัด, อำเภอ, ตำบล">
                  {getFieldDecorator('workAddress', {
                    rules: [
                      {
                        required: true,
                        message: 'กรุณาเลือกข้อมูล'
                      }
                    ],
                    })(
                      <Input.TextArea
                        placeholder="เลือกข้อมูล"
                        onClick={() => this.props.history.push('/select-work-province')}
                      />)}
                    <span className="ant-input-suffix">
                      <Icon type="right"/>
                    </span>
                </AdressForm>
              </>
              }

              <h5 style={{marginBottom: '1rem'}}>ที่อยู่จัดส่งเอกสาร</h5>
              {!otherDocumentAddress.includes(this.props.userInfomations.occupationId) &&
                <FormItemRadio>
                  {getFieldDecorator('radioDocumentAddress', {
                    rules: [
                      {
                        required: true,
                        message: 'กรุณาเลือก'
                      }
                    ],
                    })(
                    <RadioVertical onChange={this.handleDocumentAddressChange}>
                      <Radio value={'current'}>ใช้ตามที่อยู่ทะเบียนบ้าน</Radio>
                      {
                        !this.props.userInfomations.currentAddress && <Radio value={'houseRegister'}>ใช้ตามที่อยู่ปัจจุบัน</Radio>
                      }
                      {
                        this.props.userInfomations.workAddress === 'other'&& <Radio value={'work'}>ใช้ตามที่อยู่ที่ทำงาน</Radio>
                      }
                      <Radio value={'other'}>ใช้ที่อยู่อื่น</Radio>
                    </RadioVertical>,
                  )}
                </FormItemRadio>
              }

              {this.props.userInfomations.documentAddress === 'other' &&
              <>
                <Form.Item label={'เลขที่'}>
                  {getFieldDecorator('documentNumber', {
                      rules: [{ required: true,  min: 2, message: 'กรุณากรอกเลขที่', whitespace: true }],
                  })(<Input placeholder='กรอกเลขที่' onChange={this.handleDocumentNumberChange} />)}
                </Form.Item>
                <Form.Item label={'ชื่ออาคาร หรือหมู่บ้าน'}>
                  {getFieldDecorator('documentVillageName')(
                    <Input placeholder='กรอกชื่ออาคาร (ถ้ามี)' onChange={this.handleDocumentVillageNameChange} />
                  )}
                </Form.Item>
                <Form.Item label={'หมู่'}>
                  {getFieldDecorator('documentVillage')(
                    <Input placeholder='กรอกหมู่ (ถ้ามี)' onChange={this.handleDocumentVillageChange} />
                  )}
                </Form.Item>
                <Form.Item label={'ชั้น'}>
                  {getFieldDecorator('documentFloor')(
                    <Input placeholder='กรอกชั้น (ถ้ามี)' onChange={this.handleDocumentFloorChange} />
                  )}
                </Form.Item>
                <Form.Item label={'ถนน'}>
                  {getFieldDecorator('documentRoad')(
                    <Input placeholder='กรอกชื่อถนน' onChange={this.handleDocumentRoadChange} />
                  )}
                </Form.Item>
                <AdressForm label="จังหวัด, อำเภอ, ตำบล">
                  {getFieldDecorator('documentAddress', {
                    rules: [
                      {
                        required: true,
                        message: 'กรุณาเลือกข้อมูล'
                      }
                    ],
                    })(
                      <Input.TextArea
                        placeholder="เลือกข้อมูล"
                        onClick={() => this.props.history.push('/select-document-province')}
                      />)}
                    <span className="ant-input-suffix">
                      <Icon type="right"/>
                    </span>
                </AdressForm>
              </>
              }

              <Divider floatRight={true} floatLeft={true} height={5}/>
              <h5 style={{margin: '1rem 0'}}>ข้อมูลเพิ่มเติม</h5>
              <Form.Item label="สถานภาพ">
                {getFieldDecorator('maritalStatus')(
                  <RadioButton onChange={this.handleMaritalStatusChange.bind(this)}>
                    <Radio.Button value="Single">โสด</Radio.Button>
                    <Radio.Button value="Married">สมรส</Radio.Button>
                    <Radio.Button value="Divorced">หย่าร้าง</Radio.Button>
                    <Radio.Button value="Widowhood">หม้าย</Radio.Button>
                  </RadioButton>
                )}
              </Form.Item>
              <Form.Item label="จำนวนบุตร หรือบุตรบุญธรรม" extra="*ระบุเฉพาะบุคคลที่อายุไม่ถึง 20 ปี และยังไม่แต่งงาน (ไม่เกิน 2 คน)">
                {getFieldDecorator('children', {
                  rules: [
                    {
                      required: true,
                      message: 'เลือก',
                    }
                  ],
                  })(<Input
                    placeholder="เลือกข้อมูล"
                    suffix={<Icon type="right"/>}
                    onClick={() => this.props.history.push('/children')}
                  />)}
              </Form.Item>

              {
                this.props.userInfomations.maritalStatus === 'Married' &&
                <>
                  <Form.Item label="ข้อมูลคู่สมรส">
                    {getFieldDecorator('spouseNationality', {
                        initialValue: 'Thai',
                      })(
                        <RadioButton  onChange={this.handleSpouseNationalityChange.bind(this)}>
                          <Radio.Button value="Thai">สัญชาติไทย</Radio.Button>
                          <Radio.Button value="Other">สัญชาติอื่น</Radio.Button>
                        </RadioButton>
                    )}
                  </Form.Item>
                  {(this.props.userInfomations.spouseNationalityId === 'Thai' || this.props.userInfomations.spouseNationalityId === undefined) && (
                    <>
                      <Form.Item label={'เลขที่ประจำตัวบัตรประชาชน'}>
                        {getFieldDecorator('spouseCitizenId', {
                            getValueFromEvent: this.handleSpouseCitizenIdChange.bind(this),
                            rules: [{ required: true,  min: 2, message: 'กรุณากรอกเลขที่ประจำตัวบัตรประชาชน', whitespace: true }],
                        })(<Input inputmode="numeric" placeholder='9-9999-99999-99-9' />)}
                      </Form.Item>
                      {!this.props.userInfomations.spouseLifeLongCitizenId &&
                        <Form.Item label={'วันบัตรหมดอายุ'}>
                          {
                            getFieldDecorator('spouseCitizenIdExpireDate', {
                              getValueFromEvent: this.handleSpouseCitizenIdExpireDateChange.bind(this),
                              rules: [{
                                required: true && !this.props.userInfomations.spouseLifeLongCitizenId,
                                message: 'กรุณากรอกวันบัตรหมดอายุ'
                              }],
                            })(
                              <input
                                style={{lineHeight:'35px'}} type="date" required aria-required="true"
                                placeholder={this.props.userInfomations.spouseCitizenIdExpireDateText || '11 มกราคม 2554'}
                              />
                            )
                          }
                        </Form.Item>
                      }
                      <CheckboxSingle
                        onChange={this.handleSpouseLifeLongCitizenIdChange.bind(this)}
                        checked={this.props.userInfomations.spouseLifeLongCitizenId}>บัตรประชาชนตลอดชีพ
                      </CheckboxSingle>
                    </>
                  )}
                  {(this.props.userInfomations.spouseNationalityId !== 'Thai' && this.props.userInfomations.spouseNationalityId !== undefined) && (
                    <>
                      <Form.Item label="ประเทศ">
                        {getFieldDecorator('spouseCountry', {
                          rules: [
                            {
                              required: true,
                              message: 'กรุณาเลือกประเทศ',
                            }
                          ],
                          })(<Input
                            placeholder="เลือกประเทศ"
                            suffix={<Icon type="right"/>}
                            onClick={() => this.props.history.push('/select-spouse-country')}
                          />)}
                      </Form.Item>
                      <Form.Item label={'เลขที่หนังสือเดินทาง'}>
                        {getFieldDecorator('spousePassportNo', {
                          getValueFromEvent: this.handleSpousePassportNoChange.bind(this),
                          rules: [{ required: true,  min: 2, transform : this.transformToUppercase, message: 'กรุณากรอกเลขที่หนังสือเดินทาง', whitespace: true }],
                        })(<Input placeholder='กรอกเลขที่หนังสือเดินทาง'/>)}
                      </Form.Item>
                      <Form.Item label={'วันหมดอายุ'}>
                        {getFieldDecorator('spousePassportNoExpireDate', {
                            getValueFromEvent: this.handleSpousePassportNoExpireDateChange.bind(this),
                            rules: [{ required: true, message: 'กรุณากรอกวันบัตรหมดอายุ'}],
                        })(
                          <input
                            style={{lineHeight:'35px'}} type="date" required aria-required="true"
                            placeholder={this.props.userInfomations.spousePassportNoExpireDateText || '11 มกราคม 2554'}
                          />
                        )}
                      </Form.Item>
                    </>
                  )}
                  <Form.Item label="คำนำหน้า">
                    {getFieldDecorator('spouseTitle', {
                      rules: [
                        {
                          required: true,
                          message: 'กรุณาเลือกคำนำหน้า',
                        }
                      ],
                      })(<Input
                        placeholder="เลือกคำนำหน้า"
                        suffix={<Icon type="right"/>}
                        onClick={() => this.props.history.push('/select-spouse-title')}
                      />)}
                  </Form.Item>
                  <Form.Item label={'ชื่อ - นามสกุล'}>
                    {getFieldDecorator('spouseName', {
                        rules: [{ required: true,  min: 2, message: 'กรุณากรอกชื่อ - นามสกุล', whitespace: true }],
                    })(<Input placeholder='กรอกชื่อ - นามสกุล' onChange={this.handleSpouseNameChange.bind(this)} />)}
                  </Form.Item>
                </>
              }

              {(this.props.userInfomations.children === '1' || this.props.userInfomations.children === '2') && (
                <>
                  <Form.Item label="ข้อมูลบุตรคนที่ 1">
                    {getFieldDecorator('fristChildrenNationality')(
                      <RadioButton  onChange={this.handleFristChildrenNationalityChange.bind(this)}>
                        <Radio.Button value="Thai">สัญชาติไทย</Radio.Button>
                        <Radio.Button value="Other">สัญชาติอื่น</Radio.Button>
                      </RadioButton>
                    )}
                  </Form.Item>

                  {(this.props.userInfomations.fristChildrenNationalityId === 'Thai' || this.props.userInfomations.fristChildrenNationalityId === undefined) && (
                    <>
                      <Form.Item label={'เลขที่ประจำตัวบัตรประชาชน'}>
                        {getFieldDecorator('fristChildrenCitizenId', {
                            getValueFromEvent: this.handleFristChildrenCitizenIdChange.bind(this),
                            rules: [{ required: true,  min: 2, message: 'กรุณากรอกเลขที่ประจำตัวบัตรประชาชน', whitespace: true }],
                        })(<Input inputmode="numeric" placeholder='9-9999-99999-99-9'/>)}
                      </Form.Item>
                      <Form.Item label={'วันบัตรหมดอายุ'}>
                        {getFieldDecorator('fristChildrenCitizenIdExpireDate', {
                          getValueFromEvent: this.handleFristChildrenCitizenIdExpireDateChange.bind(this),
                          rules: [{
                            required: true,
                            message: 'กรุณากรอกวันบัตรหมดอายุ'
                          }],
                        })(
                          <input
                            style={{lineHeight:'35px'}} type="date" required aria-required="true"
                            placeholder={this.props.userInfomations.fristChildrenCitizenIdExpireDateText || '11 มกราคม 2554'}
                          />
                        )}
                      </Form.Item>
                    </>
                  )}

                  {(this.props.userInfomations.fristChildrenNationalityId !== 'Thai'  && this.props.userInfomations.fristChildrenNationalityId !== undefined) && (
                    <>
                      <Form.Item label="ประเทศ">
                        {getFieldDecorator('fristChildrenCountry', {
                          rules: [
                            {
                              required: true,
                              message: 'กรุณาเลือกประเทศ',
                            }
                          ],
                          })(<Input
                            placeholder="เลือกประเทศ"
                            suffix={<Icon type="right"/>}
                            onClick={() => this.props.history.push('/select-first-children-country')}
                          />)}
                      </Form.Item>
                      <Form.Item label={'เลขที่หนังสือเดินทาง'}>
                        {getFieldDecorator('fristChildrenPassportNo', {
                          getValueFromEvent: this.handleFristChildrenPassportNoChange.bind(this),
                          rules: [{ required: true,  min: 2, message: 'กรุณากรอกเลขที่หนังสือเดินทาง', whitespace: true }],
                        })(<Input placeholder='กรอกเลขที่หนังสือเดินทาง'/>)}
                      </Form.Item>
                      <Form.Item label={'วันหมดอายุ'}>
                        {getFieldDecorator('fristChildrenPassportExpire', {
                          getValueFromEvent: this.handleFristChildrenPassportNoExpireDateChange.bind(this),
                          rules: [{ required: true, message: 'กรุณากรอกวันบัตรหมดอายุ'}],
                        })(
                          <input
                            style={{lineHeight:'35px'}}
                            type="date"
                            placeholder={this.props.userInfomations.fristChildrenPassportNoExpireDateText || '11 มกราคม 2554'}
                            required aria-required="true"
                          />
                        )}
                      </Form.Item>
                    </>
                  )}

                  <Form.Item label="คำนำหน้า">
                    {getFieldDecorator('fristChildrenTitle', {
                      rules: [
                        {
                          required: true,
                          message: 'กรุณาเลือกคำนำหน้า',
                        }
                      ],
                      })(<Input
                        placeholder="เลือกคำนำหน้า"
                        suffix={<Icon type="right"/>}
                        onClick={() => this.props.history.push('/select-first-children-title')}
                      />)}
                  </Form.Item>
                  <Form.Item label={'ชื่อ - นามสกุล'}>
                    {getFieldDecorator('fristChildrenName', {
                        rules: [{ required: true,  min: 2, message: 'กรุณากรอกชื่อ - นามสกุล', whitespace: true }],
                    })(<Input placeholder='กรอกชื่อ - นามสกุล' onChange={this.handleFristChildrenNameChange.bind(this)} />)}
                  </Form.Item>
                </>
              )}

              {this.props.userInfomations.children === '2' && (
                <>
                  <Form.Item label="ข้อมูลบุตรคนที่ 2">
                    {getFieldDecorator('secondChildrenNationality')(
                      <RadioButton  onChange={this.handleSecondChildrenNationalityChange.bind(this)}>
                        <Radio.Button value="Thai">สัญชาติไทย</Radio.Button>
                        <Radio.Button value="Other">สัญชาติอื่น</Radio.Button>
                      </RadioButton>
                    )}
                  </Form.Item>

                  {(this.props.userInfomations.secondChildrenNationalityId === 'Thai' || this.props.userInfomations.secondChildrenNationalityId === undefined) && (
                    <>
                      <Form.Item label={'เลขที่ประจำตัวบัตรประชาชน'}>
                        {getFieldDecorator('secondChildrenCitizenId', {
                          getValueFromEvent: this.handleSecondChildrenCitizenIdChange.bind(this),
                          rules: [{ required: true,  min: 2, message: 'กรุณากรอกเลขที่ประจำตัวบัตรประชาชน', whitespace: true }],
                        })(<Input inputmode="numeric" placeholder='9-9999-99999-99-9'/>)}
                      </Form.Item>
                      <Form.Item label={'วันบัตรหมดอายุ'}>
                        {getFieldDecorator('secondChildrenCitizenIdExpireDate', {
                          getValueFromEvent: this.handleSecondChildrenCitizenIdExpireDateChange.bind(this),
                          rules: [{
                            required: true,
                            message: 'กรุณากรอกวันบัตรหมดอายุ'
                          }],
                        })(
                          <input
                            style={{lineHeight:'35px'}} type="date" required aria-required="true"
                            placeholder={this.props.userInfomations.secondChildrenCitizenIdExpireDateText || '11 มกราคม 2554'}
                          />
                        )}
                      </Form.Item>
                    </>
                  )}

                  {(this.props.userInfomations.secondChildrenNationalityId !== 'Thai'  && this.props.userInfomations.secondChildrenNationalityId !== undefined) && (
                    <>
                      <Form.Item label="ประเทศ">
                        {getFieldDecorator('secondChildrenCountry', {
                          rules: [
                            {
                              required: true,
                              message: 'กรุณาเลือกประเทศ',
                            }
                          ],
                          })(<Input
                            placeholder="เลือกประเทศ"
                            suffix={<Icon type="right"/>}
                            onClick={() => this.props.history.push('/select-second-children-country')}
                          />)}
                      </Form.Item>
                      <Form.Item label={'เลขที่หนังสือเดินทาง'}>
                        {getFieldDecorator('secondChildrenPassportNo', {
                          getValueFromEvent: this.handleSecondChildrenPassportNoChange.bind(this),
                          rules: [{ required: true,  min: 2, message: 'กรุณากรอกเลขที่หนังสือเดินทาง', whitespace: true }],
                        })(<Input placeholder='กรอกเลขที่หนังสือเดินทาง'/>)}
                      </Form.Item>
                      <Form.Item label={'วันหมดอายุ'}>
                        {getFieldDecorator('secondChildrenPassportNoExpireDate', {
                          getValueFromEvent: this.handleSecondChildrenPassportNoExpireDateChange.bind(this),
                          rules: [{ required: true, message: 'กรุณากรอกวันบัตรหมดอายุ'}],
                        })(
                          <input
                            style={{lineHeight:'35px'}}
                            type="date"
                            placeholder={this.props.userInfomations.secondChildrenPassportNoExpireDateText || '11 มกราคม 2554'}
                            required aria-required="true"
                          />
                        )}
                      </Form.Item>
                    </>
                  )}

                  <Form.Item label="คำนำหน้า">
                    {getFieldDecorator('secondChildrenTitle', {
                      rules: [
                        {
                          required: true,
                          message: 'กรุณาเลือกคำนำหน้า',
                        }
                      ],
                      })(<Input
                        placeholder="เลือกคำนำหน้า"
                        suffix={<Icon type="right"/>}
                        onClick={() => this.props.history.push('/select-second-children-title')}
                      />)}
                  </Form.Item>
                  <Form.Item label={'ชื่อ - นามสกุล'}>
                    {getFieldDecorator('secondChildrenName', {
                        rules: [{ required: true,  min: 2, message: 'กรุณากรอกชื่อ - นามสกุล', whitespace: true }],
                    })(<Input placeholder='กรอกชื่อ - นามสกุล' onChange={this.handleSecondChildrenNameChange.bind(this)} />)}
                  </Form.Item>
                </>
              )}
            </Form>
          </Personalnformation>
          <div className='modal-date'></div>
          <ButtonComponent
            textcolor={constants.color.white}
            bordercolor={constants.color.orange}
            backgroundcolor={constants.color.orange}
            text={'ทำรายการต่อ'}
            disabled={false}
            onClick={this.handleSubmit}/>
        </Layout>
      );
    }
}

const mapStateToProps = (state) => {
  return {
    userInfomations: state.userInfomations
  }
}

const mapDispatchToProps = {
  setCompanyName: actions.setCompanyName,
  setIncome: actions.setIncome,
  setObjective: actions.setObjective,
  setCurrentAddress: actions.setCurrentAddress,
  setCurrentNumber: actions.setCurrentNumber,
  setCurrentVillageName: actions.setCurrentVillageName,
  setCurrentVillage: actions.setCurrentVillage,
  setCurrentFloor: actions.setCurrentFloor,
  setCurrentRoad: actions.setCurrentRoad,
  setWorkAddress: actions.setWorkAddress,
  setWorkNumber: actions.setWorkNumber,
  setWorkVillageName: actions.setWorkVillageName,
  setWorkVillage: actions.setWorkVillage,
  setWorkFloor: actions.setWorkFloor,
  setWorkRoad: actions.setWorkRoad,
  setDocumentAddress: actions.setDocumentAddress,
  setDocumentNumber: actions.setDocumentNumber,
  setDocumentVillageName: actions.setDocumentVillageName,
  setDocumentVillage: actions.setDocumentVillage,
  setDocumentFloor: actions.setDocumentFloor,
  setDocumentRoad: actions.setDocumentRoad,
  setMaritalStatus: actions.setMaritalStatus,
  setSpouseNationality: actions.setSpouseNationality,
  setSpouseCitizenId: actions.setSpouseCitizenId,
  setSpouseCitizenIdExpireDate: actions.setSpouseCitizenIdExpireDate,
  setSpousePassportNo: actions.setSpousePassportNo,
  setSpousePassportNoExpireDate: actions.setSpousePassportNoExpireDate,
  setSpouseName: actions.setSpouseName,
  setSpouseLifeLongCitizenId: actions.setSpouseLifeLongCitizenId,
  setFristChildrenNationality: actions.setFristChildrenNationality,
  setFristChildrenCitizenId: actions.setFristChildrenCitizenId,
  setFristChildrenCitizenIdExpireDate: actions.setFristChildrenCitizenIdExpireDate,
  setFristChildrenPassportNo: actions.setFristChildrenPassportNo,
  setFristChildrenPassportNoExpireDate: actions.setFristChildrenPassportNoExpireDate,
  setFristChildrenName: actions.setFristChildrenName,
  setSecondChildrenNationality: actions.setSecondChildrenNationality,
  setSecondChildrenCitizenId: actions.setSecondChildrenCitizenId,
  setSecondChildrenCitizenIdExpireDate: actions.setSecondChildrenCitizenIdExpireDate,
  setSecondChildrenPassportNo: actions.setSecondChildrenPassportNo,
  setSecondChildrenPassportNoExpireDate: actions.setSecondChildrenPassportNoExpireDate,
  setSecondChildrenName: actions.setSecondChildrenName,
}

const WrappedPersonalInformationForm = Form.create({ name: 'register' })(PersonalInformationForm);

const PersonalInformationFormWithConnect = connect(mapStateToProps, mapDispatchToProps)(WrappedPersonalInformationForm)

export default PersonalInformationFormWithConnect
